import React from 'react'
import OffLine from '../off-line'

const OffLineEs = () => {
    return <OffLine languageCode="es" />
}

export default OffLineEs
